import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import PropTypes from 'prop-types';

const FloatingNotificationStack = ({ notifications, onDismiss, onClick }) => {
    return (
        <div className="floating-notification-stack">
            <AnimatePresence>
                {notifications.map((n) => (
                    <motion.div
                        key={n.id}
                        layout
                        initial={{ opacity: 0, y: -24, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, x: 80, scale: 0.9, transition: { duration: 0.2 } }}
                        transition={{ type: 'spring', stiffness: 380, damping: 28 }}
                        className="floating-notification-card"
                        onClick={() => onClick?.(n)}
                    >
                        <div className="floating-notification-avatar">
                            {n.data?.creator_profile_picture_url ? (
                                <img src={n.data.creator_profile_picture_url} alt={n.title} />
                            ) : (
                                <div className="floating-notification-avatar-fallback">
                                    {n.title?.charAt(0)?.toUpperCase() || '!'}
                                </div>
                            )}
                        </div>

                        <div className="floating-notification-content">
                            <div className="floating-notification-title">{n.title}</div>
                            <div className="floating-notification-body">{n.body}</div>
                        </div>

                        <button
                            className="floating-notification-close"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDismiss(n.id);
                            }}
                            aria-label="Dismiss notification"
                        >
                            ×
                        </button>

                        {/* auto-dismiss progress bar */}
                        <motion.div
                            className="floating-notification-progress"
                            initial={{ scaleX: 1 }}
                            animate={{ scaleX: 0 }}
                            transition={{ duration: (n.duration || 5000) / 1000, ease: 'linear' }}
                        />
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
};

FloatingNotificationStack.propTypes = {
    notifications: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            title: PropTypes.string,
            body: PropTypes.string,
            data: PropTypes.object,
            duration: PropTypes.number,
        })
    ).isRequired,
    onDismiss: PropTypes.func.isRequired,
    onClick: PropTypes.func,
};

export default FloatingNotificationStack;